module.exports = __webpack_public_path__ + "assets/img/intro-vip-a2.0655e5aa.jpg";